export function snakeCaseToCamelCase(str) {
    const splitted = str.split('-');
    if (splitted.length === 1)
        return splitted[0];
    return (splitted[0] +
        splitted
            .slice(1)
            .map((word) => word[0].toUpperCase() + word.slice(1))
            .join(''));
}
//# sourceMappingURL=snake-case-to-camel-case.js.map